<template>
  <DetailsLoader
    v-if="!lesson.hasApiData"
    :rows="7"
  />

  <LessonDetailList
    v-if="lesson.hasApiData"
    :lesson="lesson"
  />
</template>

<script lang="ts">
export default { name: 'LessonSummary' }
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { useExternalContent } from '~/composables/useExternalContent'

import { LessonRecord } from '~/types/records/LessonRecord'

import DetailsLoader from '~/components/loaders/DetailsLoader.vue'
import LessonDetailList from './LessonDetailList.vue'

const props = defineProps<{
  lessonEnc: string,
}>()

const {
  algoliaRecord,
  apiRecord,
  hasApiData,
} = useExternalContent(props.lessonEnc)

// merge all the data for use in the template
const lesson = computed(() => {
  return {
    ...algoliaRecord,
    ...apiRecord.value,
    hasApiData,
  } as LessonRecord
})
</script>
